import { CASPacketAttachmentOrderItem } from './CASPacketAttachmentOrderItem'

export const LastEditedDateAsc = new CASPacketAttachmentOrderItem({
  id: '9b4d8597-b0bb-40c8-9937-bd80fbdffcdf',
  name: 'Last edited date (oldest first)',
  field: 'lastEditedDate',
  direction: 'asc',
})

export const LastEditedDateDesc = new CASPacketAttachmentOrderItem({
  id: 'e2bb2ab3-14d1-4759-98e0-e28f5a0e8d72',
  name: 'Last edited date (newest first)',
  field: 'lastEditedDate',
  direction: 'desc',
})

export const CreatedDateAsc = new CASPacketAttachmentOrderItem({
  id: '346c6baf-e74f-4214-8973-b715cd81811a',
  name: 'Created date (oldest first)',
  field: 'createdDate',
  direction: 'asc',
})

export const CreatedDateDesc = new CASPacketAttachmentOrderItem({
  id: '2c217bb6-03fd-4dc0-b3b2-00d43c02a97f',
  name: 'Created date (newest first)',
  field: 'createdDate',
  direction: 'desc',
})

export const FilenameAsc = new CASPacketAttachmentOrderItem({
  id: 'c7bb92e2-110f-4b66-aa43-63028959315d',
  name: 'Filename (A to Z)',
  field: 'filename',
  direction: 'asc',
})

export const FilenameDesc = new CASPacketAttachmentOrderItem({
  id: '50733425-0aae-45d9-aac7-4b33b02fc72e',
  name: 'Filename (Z to A)',
  field: 'filename',
  direction: 'desc',
})
